import React, { useState, useEffect, useCallback } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Card, List, Collapse, Switch } from 'antd';
import { reqUserDetail } from '../../../../api/index';
import PropTypes from 'prop-types';
import { rTime } from '../../../../utils/dateUtils';
import LinkButton from '../../../../components/link-button';
import ShowRole from '../ShowRole';

const { Panel } = Collapse;
const Item = List.Item;

const UserDetail = ({ history, location }) => {
  const [user, setUser] = useState({});

  const getUserDetail = useCallback(async () => {
    const verbose = '100';
    const result = await reqUserDetail(location.state.email, verbose);
    if (result.status === 200) {
      let userData = result.result || {};
      userData.roles = userData.roles || [];
      setUser(userData);
    }
  }, [location.state.email]);

  useEffect(() => {
    getUserDetail();
  }, [getUserDetail]);

  const renderTitle = (
    <span>
      <LinkButton onClick={() => history.goBack()}>
        <ArrowLeftOutlined style={{ marginRight: 10, fontSize: 20 }} />
      </LinkButton>
      <span>用户详情</span>
    </span>
  );

  return (
    <Card title={renderTitle}>
      <List className='user-detail'>
        <Item>
          <span className='left'>姓名：</span>
          <span>{user.name}</span>
        </Item>
        <Item>
          <span className='left'>邮箱：</span>
          <span>{user.email}</span>
        </Item>
        <Item>
          <span className='left'>电话：</span>
          <span>{user.phone}</span>
        </Item>
        <Item>
          <span className='left'>部门：</span>
          <span>{user.department}</span>
        </Item>
        <Item>
          <span className='left'>状态：</span>
          <span>
            <Switch defaultChecked={!(user.state === 'enabled')} />
          </span>
        </Item>
        <Item>
          <span className='left'>注册时间：</span>
          <span>{rTime(user.hire_date)}</span>
        </Item>
        <Item>
          <span className='left'>出勤类型：</span>
          <span>{user.attendance_type}</span>
        </Item>
        <Item>
          <Collapse defaultActiveKey={['1']}>
            <Panel header='领导信息' key='1'>
              <div>
                <span>姓名：{user.leader?.name}</span>
              </div>
              <div>
                <span>邮箱：{user.leader?.email}</span>
              </div>
            </Panel>
          </Collapse>
        </Item>
        <Item>
          <span className='left'>角色列表：</span>
          <ShowRole user={user} />
        </Item>
      </List>
    </Card>
  );
};

UserDetail.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default UserDetail;
